import { OpenAPI as openApiAdmin } from '@api/admin'
import { OpenAPI as openApiApprovals } from '@api/approvals'
import { OpenAPI as openApiCustomers } from '@api/customers'
import { OpenAPI as openApiMachines } from '@api/machines'
import { OpenAPI as openApiPdfGeneration } from '@api/pdf-generation'
import { TOKEN_EXPIRED } from '@common/utils'
import { useCallback, useEffect } from 'react'
import { useAuth } from 'react-oidc-context'

import { useAuthStore } from '@/stores/authStore'

export const AuthBridge = () => {
  const auth = useAuth()
  const { isAuthenticated, isLoading, user } = auth
  const sync = useAuthStore(s => s._sync)

  const loginUser = useCallback(
    () => auth.signinRedirect(),
    [auth.signinRedirect]
  )
  const logoutUser = useCallback(
    () => auth.signoutRedirect(),
    [auth.signoutRedirect]
  )

  useEffect(() => {
    sync({ auth, isAuthenticated, isLoading, loginUser, logoutUser })
  }, [auth, isAuthenticated, isLoading, loginUser, logoutUser, sync])

  useEffect(() => {
    if (user) {
      const { access_token } = user
      openApiAdmin.TOKEN = access_token
      openApiApprovals.TOKEN = access_token
      openApiCustomers.TOKEN = access_token
      openApiPdfGeneration.TOKEN = access_token
      openApiMachines.TOKEN = access_token
    }
  }, [user])

  useEffect(() => {
    return auth.events.addAccessTokenExpiring(() => {
      if (document.hidden) {
        window.dispatchEvent(new CustomEvent(TOKEN_EXPIRED))
      } else {
        try {
          auth.startSilentRenew()
        } catch (error) {
          console.error(error)
          window.dispatchEvent(new CustomEvent(TOKEN_EXPIRED))
        }
      }
    })
  }, [auth.events, auth.startSilentRenew])

  useEffect(() => {
    return auth.events.addSilentRenewError(() => {
      window.dispatchEvent(new CustomEvent(TOKEN_EXPIRED))
    })
  }, [auth.events])

  return null
}
